import axios from "axios";

export const GET_ADMINISTRATION_THEREFORE_KEYWORDS_BY_FIELD_NO = "get_administration_therefore_keywords_by_field_no";

export const getAdministrationThereforeKeywordsByFieldNo = (category_no, field_no) => {
  const url = `/administration/therefore/keywords_by_field_no.json`;
  const request = axios.get(url, {
    params: { category_no, field_no },
  });
  return {
    type: GET_ADMINISTRATION_THEREFORE_KEYWORDS_BY_FIELD_NO,
    payload: request,
    meta: { category_no, field_no },
  };
};
